<template>
  <Select
    :items="clientes"
    :selectedItem="selectedItem"
    label="Cliente"
    searchPlaceholder="Buscar cliente"
    :filtro_id="filtro.filtro"
    :path="path"
    :buscaRemota="true"
    :buscando="buscando"
    @atualizar="atualizar"
    @buscar="buscarClientes"
  />
</template>
<script>
import Select from '../../components/Select.vue';

export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  components: {
    Select
  },
  data() {
    return {
      clientes: [],
      selectedItem: {
        id: "",
        name: "",
      },
      buscando: false,
      termoAtual: ''
    }
  },
  methods: {
    atualizar(item) {
      this.selectedItem = item;
      this.$aplicaFiltroEmURL(this.filtro.filtro, this.selectedItem.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.selectedItem.id
      });
    },
    buscarClientes(term = '') {
      const { parametros } = this.filtro;
      const paramsDefault = { params: { tipos: 'cliente' } };
      if (parametros && typeof parametros === 'object') {
        paramsDefault.params = { ...paramsDefault.params, ...parametros };
      }
      this.buscando = true;
      this.termoAtual = term;
      this.$api.get('/stakeholders/busca_todos', { params: { ...paramsDefault.params, term } }).then(response => {
        if (this.termoAtual !== term) return;
        const stakeholders = response.data;
        this.clientes = stakeholders.map(stakeholder => ({
          id: stakeholder.id,
          name: stakeholder.label
        }));
        const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
        this.$renderFiltroSelect(filtroAplicado, this.clientes, this.selectedItem);
      }).catch(error => {
        if (this.termoAtual !== term) return;
        console.error('Erro ao buscar clientes:', error);
      }).finally(() => {
        if (this.termoAtual === term) {
          this.buscando = false;
        }
      });
    },
  },
  mounted() {
    this.buscarClientes();
  }
}
</script>
